module.exports = __webpack_public_path__ + "static/img/iphone-x-mockup-vertical.b9f4d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iphone-x-mockup-vertical.png
// module id = +YLs
// module chunks = 1